<script>
import VTooltipWrapper from "../../../common/v-tooltip-wrapper.vue";
import ConfirmDialog from "../../../dialog/confirm-dialog.vue";

export default {
    name: "publish-publish-button",
    components: {ConfirmDialog, VTooltipWrapper},
    props: {
        disabled: Boolean,
        loading: Boolean,
        color: String,
        dialogText: String,
        dialogAdditionalText: String
    },
    data() {
        return {
            showDialog: false
        }
    },
    computed: {
        translations() {
            return {
                publish: Lang.langGet("Publish"),
                cancel: Lang.langGet("Cancel"),
                tooltip: Lang.langGet("Publish currently not available due to server/connection issues!<br>Please contact your System Administrator"),
                publishTitle: Lang.langGet("Do you really want to publish?"),
            }
        }
    },
    methods: {
        handleClick() {
            this.showDialog = true;
        },
        handleCancel() {
            this.showDialog = false;
        },
        handleConfirm() {
            this.showDialog = false;
            this.$emit('publish');
        }
    }
}
</script>

<template>
    <div id="publish-publish-button">
        <v-btn :disabled="disabled" type="button" :class="`btn btn-${color}`" @click="handleClick">
            <v-icon left>far {{ loading ? 'fa-spinner fa-spin-pulse' : 'fa-paper-plane' }}</v-icon>
            {{ translations.publish }}
        </v-btn>
        <v-tooltip-wrapper v-if="disabled" activator="#publish-publish-button" tooltip-position="bottom">
            <div v-html="translations.tooltip"/>
        </v-tooltip-wrapper>
        <confirm-dialog
            :title="translations.publishTitle"
            :message="dialogText"
            :confirmMsg="dialogAdditionalText"
            :showTextIcon="!!dialogAdditionalText"
            :confirmText="translations.publish"
            :abortText="translations.cancel"
            @confirm="handleConfirm"
            @cancel="handleCancel"
            :showDialog="showDialog"
            noIcons
        />
    </div>
</template>
